// extracted by mini-css-extract-plugin
export default {"overridePatronBlockHeader":"overridePatronBlockHeader---zUaF9","patronBlock":"patronBlock---cMII3","overridePatronBlock":"overridePatronBlock---erADZ"};